import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class LoanCalculatorModel extends BaseModel {
  @Expose() loanAmount!: number;
  @Expose() holdback!: number;
}
